module.exports = __webpack_public_path__ + "static/assets/7275dab49c267d0b91946f605526be82.svg";